export default __webpack_public_path__ + "static/media/eyebrows_lashes.5e9c95fe.png";